var _circle, _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServerError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.9211 45.6597H59.5395C58.8324 42.9209 57.3712 40.4353 55.322 38.4855C53.2727 36.5356 50.7177 35.1996 47.9471 34.6294C45.1766 34.0591 42.3016 34.2773 39.6489 35.2594C36.9962 36.2414 34.6721 37.9478 32.9407 40.1847C31.2094 42.4216 30.1402 45.0993 29.8546 47.9135C29.569 50.7277 30.0786 53.5655 31.3253 56.1046C32.572 58.6437 34.5059 60.7822 36.9073 62.2771C39.3086 63.772 42.0812 64.5633 44.9098 64.5612H61.9211C64.4276 64.5612 66.8314 63.5655 68.6038 61.7931C70.3762 60.0208 71.3719 57.617 71.3719 55.1105C71.3719 52.604 70.3762 50.2001 68.6038 48.4278C66.8314 46.6554 64.4276 45.6597 61.9211 45.6597Z",
    stroke: "#8C8C8C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.3787,
    y: 28.9412,
    width: 6,
    height: 69.5512,
    rx: 3,
    transform: "rotate(-45 20.3787 28.9412)",
    fill: "#8C8C8C",
    stroke: "#F2F2F2",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerError);
export default __webpack_public_path__ + "static/media/server-error.5faa5c68.svg";
export { ForwardRef as ReactComponent };